module.exports = __webpack_public_path__ + "img/left-arrow.5304bcc9.svg";